import { createStyles, makeStyles } from '@material-ui/core/styles';
import { graphql, StaticQuery } from 'gatsby';
import React from 'react';
import Helmet from 'react-helmet';
import CookieConsent from 'react-cookie-consent';
import '../assets/sass/new-age.scss';

const useStyles = makeStyles(() =>
  createStyles({
    top: {
      position: 'relative',
      minHeight: '100vh',
    },
    buttonWrapper: {
      flex: 1,
      justifyContent: 'center',
      alignItems: 'center',
      display: 'flex',
      flexDirection: 'row',
    },
    button: {
      width: 180,
    },
  })
);

const Layout = ({ children }) => {
  const styles = useStyles();
  return (
    <StaticQuery
      query={graphql`
        query SiteTitleQuery {
          site {
            siteMetadata {
              title
            }
          }
        }
      `}
      render={(data) => (
        <>
          <Helmet
            title={data.site.siteMetadata.title}
            meta={[
              {
                name: 'description',
                content:
                  'The complete platform for Concept2 indoor machines: RowerErg, BikeErg, and SkiErg.',
              },
              {
                name: 'keywords',
                content:
                  'concept2,c2,rower,rowerg,skierg,bikeerg,indoor rowing,erg,logbook,workout,competition,wod,heart rate',
              },
            ]}
          >
            <html lang="en" />
          </Helmet>
          <div className={styles.top}>{children}</div>
          <CookieConsent
            buttonWrapperClasses={styles.buttonWrapper}
            buttonClasses={styles.button}
          >
            This website uses cookies to ensure you get the best user
            experience. <a href="/privacy">Learn more</a>
          </CookieConsent>
        </>
      )}
    />
  );
};

export default Layout;
